import { Core } from "@faire/design-tokens";
import { Button } from "@faire/web/slate/Button";
import { Typography } from "@faire/web/slate/Typography";
import privacyPath from "@faire/web-api--source/routes/www/privacy";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";

export const IdentityVerificationPolicy = () => {
  return (
    <Typography variant="labelSansRegular" color={Core.text.disabled}>
      <StrictLocalMsg
        defaultMessage="We use manual and automated processes to verify all retailers on Faire. <LinkFormatting>Privacy at Faire</LinkFormatting>"
        description={{
          text: "Legal disclaimer about the identity verification process",
          img: "https://cdn.faire.com/fastly/1a2176ab3ba86d35455aa10f986882215f2686c2c31e358ac955145c9e00f273.png",
        }}
        values={{
          LinkFormatting: PrivacyPathLink,
        }}
      />
    </Typography>
  );
};

const PrivacyPathLink = (chunks: React.ReactNode) => (
  <Button
    variant="tertiary"
    target="_blank"
    style={{ color: "inherit", fontSize: "inherit", textDecorationColor: "inherit" }}
    linkTo={privacyPath()}
  >
    {chunks}
  </Button>
);
